import { stopComponents } from '@gondel/core';
import { Tooltip, ITooltipFetchService } from './tooltip';
import { TooltipPopup } from '../elements/tooltip-popup/js/tooltip-popup';
import ajax from '@swisslife/shared-ui/src/utils/ajax/js/ajax';

export class TooltipFactory {
	public static initInlineTooltips(
		el: JQuery.PlainObject | HTMLElement | string,
		trigger: string,
		inlineModifier: string
	) {
		if (el) {
			const $provider = $(el);
			if ($provider) {
				const service: ITooltipFetchService = {
					uri: $provider.data('tooltip-uri'),
					uriSuffix: $provider.data('tooltip-uri-suffix') || 'html',
				};
				const error: string = $provider.data('tooltip-error');
				if (service) {
					const $tooltipTriggers = $provider.find(trigger);
					if ($tooltipTriggers.length) {
						$tooltipTriggers.each((index, tooltipTrigger) => {
							const $tooltipTrigger = $(tooltipTrigger);
							if ($tooltipTrigger) {
								const tooltipId = $tooltipTrigger.text();
								stopComponents($tooltipTrigger);
								$tooltipTrigger.empty();
								TooltipPopup.createTooltipPopup(error).then((tooltipPopup) => {
									Tooltip.createInlineTooltip(
										$tooltipTrigger,
										inlineModifier,
										tooltipId,
										service
									).then((tooltip) => {
										tooltip.bindTooltipPopup(tooltipPopup);
									});
								});
							}
						});
					}
				}
			}
		}
	}

	public static async getContentFragment(service: ITooltipFetchService, id: string): Promise<string> {
		// if the content is already on the cache
		if (TooltipFactory.fragmentCache[id]) {
			return Promise.resolve(TooltipFactory.fragmentCache[id]);
		}
		// if there is already a request being made
		if (TooltipFactory.requestCache[id]) {
			return (await TooltipFactory.requestCache[id])[0];
		}
		// let's get the content fragment
		try {
			const fetchContentUrl = TooltipFactory.generateTooltipUrl(service, id);
			TooltipFactory.requestCache[id] = Promise.all([ajax<string>(fetchContentUrl), TooltipFactory.wait(150)]);
			const fragment = (await TooltipFactory.requestCache[id])[0];
			TooltipFactory.fragmentCache[id] = fragment;
			return fragment;
		} catch (ex) {
			return Promise.reject(ex);
		} finally {
			TooltipFactory.requestCache[id] = false;
			delete TooltipFactory.requestCache[id];
		}
	}

	private static requestCache = {};
	private static fragmentCache = {};

	private static generateTooltipUrl(service: ITooltipFetchService, id: string) {
		return [service.uri, `id-${id}`, service.uriSuffix].join('.');
	}

	private static wait(delay: number) {
		return new Promise((receive) => setTimeout(receive, delay));
	}
}
